module.exports = __webpack_public_path__ + "img/logo.fe486bdb.png";